import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Layout from '../components/Layout';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table
} from 'reactstrap';

const PricingTiers = () => {
    const [pricingTiers, setPricingTiers] = useState([]);
    const [newPricingTier, setNewPricingTier] = useState({
        name: ''
    });
    const [editModal, setEditModal] = useState(false);
    const [editPricingTier, setEditPricingTier] = useState(null);
    const [addModal, setAddModal] = useState(false); // Add state for add modal

    useEffect(() => {
        fetchPricingTiers();
    }, []);

    const fetchPricingTiers = async () => {
        try {
            const response = await api.get('/pricing-tiers/');
            setPricingTiers(response.data);
        } catch (error) {
            console.error('Error fetching pricing tiers:', error);
        }
    };

    const handleInputChange = (e) => {
        if (editModal) {
            setEditPricingTier({
                ...editPricingTier,
                [e.target.name]: e.target.value
            });
        } else {
            setNewPricingTier({
                ...newPricingTier,
                [e.target.name]: e.target.value
            });
        }
    };

    const addPricingTier = async () => {
        try {
            await api.post('/pricing-tiers/', newPricingTier);
            fetchPricingTiers();
            setNewPricingTier({
                name: ''
            });
            toggleAddModal(false); // Close the modal after adding
        } catch (error) {
            console.error('Error adding pricing tier:', error);
        }
    };

    const deletePricingTier = async (id) => {
        try {
            await api.delete(`/pricing-tiers/${id}/`);
            fetchPricingTiers();
        } catch (error) {
            console.error('Error deleting pricing tier:', error);
        }
    };

    const editPricingTierSubmit = async () => {
        try {
            await api.put(`/pricing-tiers/${editPricingTier.id}/`, editPricingTier);
            fetchPricingTiers();
            toggleEditModal(false); // Close the modal after editing
        } catch (error) {
            console.error('Error editing pricing tier:', error);
        }
    };

    const openAddModal = () => {
        setNewPricingTier({
            name: ''
        });
        toggleAddModal(true);
    };

    const closeAddModal = () => {
        toggleAddModal(false);
    };

    const openEditModal = (pricingTier) => {
        setEditPricingTier(pricingTier);
        toggleEditModal(true);
    };

    const closeEditModal = () => {
        toggleEditModal(false);
    };

    const toggleAddModal = (open) => {
        setAddModal(open);
    };

    const toggleEditModal = (open) => {
        setEditModal(open);
    };

    return (
        <Layout>
            <Card>
                <CardHeader tag="h3">Pricing Tiers</CardHeader>
                <CardBody>
                    {addModal && (
                        <Modal isOpen={addModal} toggle={closeAddModal}>
                            <ModalHeader toggle={closeAddModal}>Add New Pricing Tier</ModalHeader>
                            <ModalBody>
                                <Form>
                                    <FormGroup row>
                                        <Label sm={2}>Name</Label>
                                        <Col sm={10}>
                                            <Input type="text" name="name" value={newPricingTier.name} onChange={handleInputChange} placeholder="Name" />
                                        </Col>
                                    </FormGroup>
                                </Form>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={closeAddModal}>Cancel</Button>
                                <Button color="primary" onClick={addPricingTier}>Add Pricing Tier</Button>
                            </ModalFooter>
                        </Modal>
                    )}

                    {editModal && (
                        <Modal isOpen={editModal} toggle={closeEditModal}>
                            <ModalHeader toggle={closeEditModal}>Edit Pricing Tier</ModalHeader>
                            <ModalBody>
                                <Form>
                                    <FormGroup row>
                                        <Label sm={2}>Name</Label>
                                        <Col sm={10}>
                                            <Input type="text" name="name" value={editPricingTier.name} onChange={handleInputChange} placeholder="Name" />
                                        </Col>
                                    </FormGroup>
                                </Form>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={closeEditModal}>Cancel</Button>
                                <Button color="primary" onClick={editPricingTierSubmit}>Update Pricing Tier</Button>
                            </ModalFooter>
                        </Modal>
                    )}

                    <Card>
                        <CardBody>
                            <Table striped bordered hover responsive size="sm">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pricingTiers.map(pricingTier => (
                                        <tr key={pricingTier.id}>
                                            <td>{pricingTier.name}</td>
                                            <td>
                                                <Button color="primary" onClick={() => openEditModal(pricingTier)}>Edit</Button>
                                                {' '}
                                                <Button color="danger" onClick={() => deletePricingTier(pricingTier.id)}>Delete</Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <Row>
                                <Col md={12}>
                                    <Button color="primary" onClick={() => openAddModal()}>
                                        Add Pricing Tier
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </CardBody>
            </Card>
        </Layout>
    );
};

export default PricingTiers;
